import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { ViewModule } from 'src/app/view/view.module';

import { ConfigPanelModule } from '../components/config-panel/config-panel.module';
import { FooterModule } from '../components/footer/footer.module';
import { ProgressBarModule } from '../components/progress-bar/progress-bar.module';
import { QuickpanelModule } from '../components/quickpanel/quickpanel.module';
import { SearchModule } from '../components/search/search.module';
import { SidebarModule } from '../components/sidebar/sidebar.module';
import { LayoutComponent } from './layout.component';
import { SidenavModule } from './sidenav/sidenav.module';
import { ToolbarModule } from './toolbar/toolbar.module';

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    ConfigPanelModule,
    FontAwesomeModule,
    FooterModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    ProgressBarModule,
    QuickpanelModule,
    RouterModule,
    SearchModule,
    SidebarModule,
    SidenavModule,
    ToolbarModule,
    ViewModule
  ]
})
export class LayoutModule {}
